import { render, staticRenderFns } from "./ChildWelfareAgency.vue?vue&type=template&id=6ec73c4f&scoped=true&"
import script from "./ChildWelfareAgency.vue?vue&type=script&lang=js&"
export * from "./ChildWelfareAgency.vue?vue&type=script&lang=js&"
import style0 from "./ChildWelfareAgency.vue?vue&type=style&index=0&id=6ec73c4f&prod&lang=less&scoped=true&"
import style1 from "./ChildWelfareAgency.vue?vue&type=style&index=1&id=6ec73c4f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec73c4f",
  null
  
)

export default component.exports